import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import t from '../../lang/t';
import HelperService from '../../services/HelperService';
import TypesService from '../../services/TypesService';
import Icon from '../Icon/Icon';

import './AssetItem.scss';

const AssetItem = ({
	currencySymbol = '',
	accountsAmount = 0,
	balance = 0,
	balanceFiat = 0,
	viewsBalances,
	fiatSymbol = '$',
	iconSize = 56,
	onClick,
}) => {
	const theme = useSelector(state => state?.app?.theme);
	const icon = TypesService.IconsBySymbol[currencySymbol];

	const formatCurrencySymbol = symbol => {
		const symbolParts = symbol?.split('-');
		return symbolParts?.length > 1 ? (
			<div className='Symbol'>
				<div className='Symbol__Primary'>{symbolParts[0]}</div>
				<div className='Symbol__Secondary'>{symbolParts[1]}</div>
			</div>
		) : (
			<div className='Symbol'>
				<div className='Symbol__Primary'>{symbol}</div>
			</div>
		);
	};

	return (
		<div className={classNames('AssetItem', { [theme]: true })} onClick={onClick}>
			<div className='AssetItem__Row'>
				<div className='AssetItem__Col'>
					<Icon width={iconSize} height={iconSize} type={icon} />
				</div>
			</div>
			<div className='AssetItem__Row'>
				<div className='AssetItem__Col'>{formatCurrencySymbol(currencySymbol)}</div>
				<div className='AssetItem__Col Accounts'>
					{t('Addresses')}: {viewsBalances ? accountsAmount : '***'}
				</div>
			</div>
			<div className='AssetItem__Row Row__Balance'>
				<div className='AssetItem__Col Col__Balance'>
					{viewsBalances
						? HelperService.FormatCrypto(balance, HelperService.GetCurrencyPrecisionByName(currencySymbol))
						: '******'}
				</div>
				<div className='AssetItem__Col Col__BalanceFiat'>
					{fiatSymbol}&nbsp; {viewsBalances ? HelperService.FormatFiatWithoutCurrency(balanceFiat) : '******'}
				</div>
			</div>
		</div>
	);
};

AssetItem.propTypes = {
	currencySymbol: PropTypes.string,
	accountsAmount: PropTypes.number,
	balance: PropTypes.number,
	balanceFiat: PropTypes.number,
	viewsBalances: PropTypes.bool,
	fiatSymbol: PropTypes.string,
	iconSize: PropTypes.number,
	onClick: PropTypes.func,
};

export default AssetItem;
